import PasswordPage from '@/pages/auth/PasswordPage.tsx';
import {ReactElement} from 'react';

export default function ActivatePage(): ReactElement {
	return (
		<PasswordPage title="Activate Your Account" successMessage="Your password has been set. Please log in.">
			<p>
				Welcome to the Inventory Hub. Please enter your new password below to finish activating your account.
			</p>
		</PasswordPage>
	);
}
